import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { BookOpen } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { AIContent } from "../components/AIContent";
import { ArticleStrip } from "../components/ArticleStrip";
import { T } from "../context/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const labelColor = {
  "Official announcement": "bg-blue-100 text-blue-700",
  "Analysis": "bg-purple-100 text-purple-700",
  "Opinion": "bg-amber-100 text-amber-700",
  "Community report": "bg-emerald-100 text-emerald-700",
  "Research summary": "bg-cyan-100 text-cyan-700",
  "Wire / licensed content": "bg-slate-200 text-slate-700",
};

export default function NewsPage() {
  const [news, setNews] = useState([]);

  useEffect(() => {
    axios.get(`${API}/news`).then((r) => setNews(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      <PageHero topic="sports press media broadcast" title="News, Publications & Media" subtitle="Global, national and local sports news — every item labeled by type, with event date shown separately from publication date." listenTargetId="page-content" />
      <div id="page-content" className="mx-auto max-w-7xl space-y-10 px-4 py-12 sm:px-6">
        <AIContent topic="The state of sports media — trust, labels and local coverage" context="Editorial on trustworthy sports journalism: labeling content types, verifying scores and transfers before headlines, and supporting local sports coverage." />
        <Link to="/publications" data-testid="publications-directory-link" className="inline-flex items-center gap-2 rounded-full bg-[#0055FF] px-5 py-2.5 text-sm font-bold text-white hover:bg-[#0040CC]">
          <BookOpen className="h-4 w-4" /> <T>Browse the Publications & Media Directory</T> →
        </Link>
        <ArticleStrip title="Editorial Features" limit={3} />
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-2" data-testid="news-grid">
          {news.map((n) => (
            <article key={n.id} data-testid={`news-card-${n.id}`} className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition-all hover:-translate-y-0.5 hover:shadow-md">
              <div className="flex flex-wrap items-center gap-2">
                <span className={`rounded-full px-2.5 py-1 text-[10px] font-bold uppercase ${labelColor[n.label] || "bg-slate-100 text-slate-600"}`}><T>{n.label}</T></span>
                <span className="rounded-full bg-slate-100 px-2.5 py-1 text-[10px] font-semibold text-slate-500">{n.sport}</span>
                <span className="rounded-full bg-slate-100 px-2.5 py-1 text-[10px] font-semibold text-slate-500">{n.region}</span>
              </div>
              <h3 className="mt-3 text-lg font-bold leading-snug text-slate-900"><T>{n.title}</T></h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600"><T>{n.summary}</T></p>
              <p className="mt-4 border-t border-slate-100 pt-3 text-[11px] text-slate-400">
                <T>Published</T>: {n.published} · <T>Event date</T>: {n.event_date}
              </p>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
